export default "__VITE_ASSET__DpvjSyL1__"